import { render, staticRenderFns } from "./RiskPlan.vue?vue&type=template&id=4ee19014&"
import script from "./RiskPlan.vue?vue&type=script&lang=js&"
export * from "./RiskPlan.vue?vue&type=script&lang=js&"
import style0 from "./RiskPlan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports